import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MaintenanceDialogService } from '../../../service/shared/maintenance-dialog.service';

@Component({
  selector: 'app-maintenance-notification',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './maintenance-notification.component.html',
  styleUrl: './maintenance-notification.component.scss'
})
export class MaintenanceNotificationComponent {
  showNotification:boolean = false;
  dateTimeText:string = null;
  
  constructor(private maintenanceDialogService: MaintenanceDialogService){
    effect(()=>{
      const showMaintenanceNotification = sessionStorage.getItem('showMaintenanceNotification');
      if (this.maintenanceDialogService.scheduleMaintenanceNotification() && showMaintenanceNotification != 'N') {
        this.showNotification = true
        this.dateTimeText = this.maintenanceDialogService.getStartDateTimeToEndDateTimeText();
      } else {
        this.showNotification = false
      }
    })
  }

  ngOnInit(){
    this.dateTimeText = this.maintenanceDialogService.getStartDateTimeToEndDateTimeText();
  }
  

  hideNotification(){
    this.showNotification = false;
    sessionStorage.setItem('showMaintenanceNotification','N');
  }

}
